// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import echarts from 'echarts'
// import Print from './utils/print'
import Print from './utils/nbprint/index'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import VueAMap from 'vue-amap'  //引入地图
VXETable.use(VXETablePluginExportXLSX)
Vue.use(Print)

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium'
})

Vue.use(VXETable)
Vue.prototype.$XTModal = VXETable.modal

Vue.use(VueAMap)				//全局注册
VueAMap.initAMapApiLoader({ 	//初始化
  key: 'd77a756682f8cdd1c88ed2592773d406',	//高德地图api开放平台申请的key
  plugin: ['AMap.CitySearch', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.ToolBar', 'AMap.Scale'], //需要用到的插件 
  v: '1.4.2'	//版本号
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js